import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./birthday.module.css";
import birthday from "../../assets/images/birthday.png"
const Birthday = () => {
    const [scrollPosition, setScrollPosition] = useState(0);
    const bannerRef = useRef(null);
    const requestRef = useRef();

    useEffect(() => {
        function handleScroll() {
            requestRef.current = requestAnimationFrame(() => {
                const bannerTop = bannerRef.current.offsetTop;
                const bannerHeight = bannerRef.current.offsetHeight;
                const scrollTop = window.scrollY;
                const scrollBottom = scrollTop + window.innerHeight;

                // check if the banner is in view
                if (scrollTop < bannerTop + bannerHeight && scrollBottom > bannerTop) {
                    const progress = (scrollBottom - bannerTop) / (bannerHeight + window.innerHeight);
                    setScrollPosition(progress);
                } else {
                    setScrollPosition(0);
                }
            });
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            cancelAnimationFrame(requestRef.current);
        };
    }, []);

    const titleStyle = {
        background: `linear-gradient(to left, #FFF ${scrollPosition * 180}%, transparent 0)`,
    };
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/birthday");
        window.scrollTo(0, 0);

    };

    return (
        <div ref={bannerRef} className={styles.birthdayContainer}>
            <div className={styles.describContainer}>
                <div className={styles.titleContaoner}>
                    <h2 style={titleStyle} id={styles.birthTitle}> تولد در هلیوم پارک  </h2>
                </div>
                <p id={styles.birthParagraph}>
                جشن تولد یا دورهمی‌تون رو در هلیوم پارک برگزار کنید و یک خاطره فراموش نشدنی و خوش بسازید
                </p>
                <div className={styles.birthBtnReserve}>
                    <button onClick={handleClick}  type="button" className={styles.birthBtn}>
                        رزرو
                    </button>
                </div>
            </div>
            <div className={styles.birthimgContainer}>
                <img className={styles.birthimg} src={birthday} alt="birthday" />
            </div>
        </div>
    )
}
export default Birthday;